import { render, staticRenderFns } from "./TResizableVerticalPanel.vue?vue&type=template&id=0aa8331d&scoped=true&"
import script from "./TResizableVerticalPanel.vue?vue&type=script&lang=js&"
export * from "./TResizableVerticalPanel.vue?vue&type=script&lang=js&"
import style0 from "./TResizableVerticalPanel.vue?vue&type=style&index=0&id=0aa8331d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8331d",
  null
  
)

export default component.exports